import React, {FC, useMemo} from 'react';
import styled from 'styled-components';

const StepContainer = styled.div`
    direction: ${p => p.theme.muiTheme.direction};
`;

const StepDot = styled.div<{
    isActive: boolean;
}>`
    display: inline-block;
    cursor: pointer;
    padding: 8px;

    &:after {
        display: block;
        content: '';
        width: 8px;
        height: 8px;
        border-radius: 50%;

        background-color: ${p =>
            p.isActive
                ? p.theme.muiTheme.palette.common.white
                : p.theme.muiTheme.palette.dividerStrong};
    }
`;

interface StepperProps {
    steps: number;
    activeStep: number;
    onClick: (stepIndex: number) => void;
}

const Stepper: FC<StepperProps> = ({steps, activeStep, onClick}: StepperProps) => {
    const stepsData = useMemo(
        () => new Array(steps).fill(null).map((_, index) => `step-${index}`),
        [steps]
    );

    return (
        <StepContainer>
            {stepsData.map((key, index) => (
                <StepDot key={key} isActive={index === activeStep} onClick={() => onClick(index)} />
            ))}
        </StepContainer>
    );
};

export default Stepper;
